import { loadPartneroForReferral } from "./partneroLoader";

// Imported at the top of src/index.js, before the router can rewrite the landing URL: a
// visitor who arrived through a partner link gets the Partnero script (and so its referral
// cookie) on this visit. Any other load never touches the third-party script.
loadPartneroForReferral();
